module.exports = __webpack_public_path__ + "img/life.d7de7ea.svg";